import Storage from '@aws-amplify/storage';
import { faFolderOpen, faFolderUpload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import {
  Tooltip,
  OverlayTrigger,
  Button,
  Col,
  Form,
  Row,
  Spinner,
} from 'react-bootstrap';

Storage.configure({
  AWSS3: {
    bucket: 'labsmarts-next',
    region: 'us-east-1',
  },
});

export const Upload = ({
  setState,
  clearForm,
  showModal,
  isUploadAvailable,
}) => {
  const inputFile = useRef(null);

  const [lab, setLab] = useState('Labcorp');
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);

  const openUploadPDFInfoWindow = () => {
    window.open('https://labsmarts.com/upload_test_results');
  };

  //openUploadPDFInfoWindow = () => {
  //  window.open('https://labsmarts.com/upload_test_results');
  //}

  const handleUpload = async e => {
    const newFile = e.target.files[0];

    if (!newFile) return;

    const name = newFile.name?.replaceAll(' ', '_');

    if (!newFile) return;

    setLoading(true);
    setFile(newFile?.name);

    try {
      await Storage.put(name, newFile);

      const res = await fetch(
        process.env.ENV === 'prod'
          ? 'https://fr3g7xel6oznoyhlvtu2ohqr6u0cbwao.lambda-url.us-east-1.on.aws/'
          : 'https://b6oxxdcpa6zsxddhvnqa7f55zy0kushi.lambda-url.us-east-1.on.aws/',
        { method: 'POST', body: JSON.stringify({ lab, name }) },
      );
      const {
        fileName,
        results,
        fields: { collectionDate },
      } = await res.json();

      if (inputFile.current.value?.replaceAll(' ', '_')?.endsWith(fileName)) {
        setLoading(false);
        setState({
          ...results,
          collectionDate: moment(collectionDate).startOf('day').toISOString(),
          collectionDateForUI: moment(collectionDate).toDate(),
        });
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    clearForm();
    setFile(null);
    setLoading(false);
    inputFile.current.value = null;
  };

  const panelTooltip = (
    <Tooltip id="modal-tooltip">
      Click this icon to learn more about the labs we support.
    </Tooltip>
  );

  return (
    <>
      {/* <Form.Group as={Row} key="lab-group" controlId="lab-group">
        <Form.Label column sm>
          Lab
        </Form.Label>
        <Col sm>
          <DropdownButton id="dropdown-basic-button" title={lab}>
            <Dropdown.Item onClick={() => setLab('Labcorp')}>
              Labcorp
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setLab('Labcorp Old')}>
              Labcorp Old
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setLab('Quest')}>Quest</Dropdown.Item>
          </DropdownButton>
        </Col>
        <Col sm></Col>
      </Form.Group> */}
      <Form.Group
        as={Row}
        key="upload-group"
        controlId="upload-group"
        className="d-flex align-items-center"
      >
        <Form.Label column sm={4}>
          Upload Test Results&nbsp;
          <OverlayTrigger overlay={panelTooltip}>
            <FontAwesomeIcon
              className="external-link"
              icon="external-link-alt"
              onClick={openUploadPDFInfoWindow}
            />
          </OverlayTrigger>
        </Form.Label>
        <Col className="d-flex">
          <Button
            variant="primary"
            disabled={loading}
            className="d-flex align-items-center"
            onClick={() =>
              isUploadAvailable ? inputFile.current.click() : showModal()
            }
          >
            <FontAwesomeIcon
              icon={file ? faFolderUpload : faFolderOpen}
              className="mr-3"
            />
            Browse
            <Spinner
              className="ml-3"
              animation="border"
              size="sm"
              hidden={!loading}
            />
          </Button>
          <input
            hidden
            type="file"
            ref={inputFile}
            onChange={handleUpload}
            className="form-control-file"
          />
          {file && (
            <b className="ml-4">
              {file}{' '}
              <Button variant="link" onClick={handleCancel}>
                {loading ? 'Cancel' : 'Clear'}
              </Button>
            </b>
          )}
        </Col>
      </Form.Group>
    </>
  );
};

const allFields = [
  'whiteBloodCells',
  'redBloodCells',
  'hemoglobin',
  'hematocrit',
  'meanCorpuscularVolume',
  'meanCorpuscularHGB',
  'mchConcentration',
  'rbcDistributionWidth',
  'plateletCount',
  'meanPlateletVolume',
  'neutrophilsPercent',
  'lymphocytesPercent',
  'monocytesPercent',
  'eosinophilsPercent',
  'basophilsPercent',
  'neutrophilsAbsolute',
  'lymphocytesAbsolute',
  'monocytesAbsolute',
  'eosinophilsAbsolute',
  'basophilsAbsolute',
  'glucose',
  'bun',
  'creatinine',
  'eGFR',
  'eGFRforAA',
  'bunCreatinineRatio',
  'sodium',
  'potassium',
  'chloride',
  'carbonDioxide',
  'calcium',
  'protein',
  'albumin',
  'globulin',
  'albuminGlobulinRatio',
  'bilirubin',
  'alkalinePhosphatase',
  'ast',
  'alt',
  'cholesterol',
  'hdl',
  'triglycerides',
  'ldl',
  'cholesterolHDLRatio',
  'triglyceridesHDLRatio',
  'apolipoproteinA1',
  'apolipoproteinB',
  'apoBapoA1Ratio',
  'lipoproteinA',
  'iron',
  'tibc',
  'saturation',
  'ferritin',
  'transferrin',
  'tsh',
  't4Total',
  't4Free',
  't3Total',
  't3Free',
  'reverseT3',
  'tpoAb',
  'tgAb',
  'tbg',
  't3Uptake',
  'freeT4Index',
  'amylase',
  'bileAcids',
  'bilirubinDirect',
  'bilirubinIndirect',
  'ceruloplasmin',
  'copperRBCμgmL',
  'copperRBCμgdL',
  'copperSerumμgdL',
  'copperSerummcgmL',
  'cpeptide',
  'dDimer',
  'fibrinogen',
  'folateRBC',
  'folateSerum',
  'ggt',
  'hemoglobinA1c',
  'homocysteine',
  'hsCRP',
  'insulin',
  'lactateDehydrogenase',
  'magnesiumRBC',
  'magnesium',
  'phosphorus',
  'reticulocyteCount',
  'esr',
  'uricAcid',
  'vitaminB6',
  'vitaminB12',
  'vitaminD',
  'vitaminD125',
  'zincRBCμgdL',
  'zincRBCmgL',
  'zincSerumμgdL',
  'zincSerummcgmL',
  'antiMullerianHormone',
  'cortisolAM',
  'cortisolPM',
  'dheaS',
  'dihydrotestosterone',
  'estradiolE2',
  'estriolE3',
  'estrogensTotal',
  'estroneE1',
  'fsh',
  'hCG',
  'igf1',
  'lh',
  'pregnenolone',
  'progesterone',
  'hydroxyprogesterone17',
  'prolactin',
  'prolactinLactating',
  'shbg',
  'testosteroneBioavailable',
  'testosteroneBioavailablePercent',
  'testosteroneFreeCalc',
  'testosteroneFreeDirect',
  'testosteroneTotal',
  'testosteroneTotalLCMS',
];

const filteredFields = [
  'whiteBloodCells',
  'redBloodCells',
  'hemoglobin',
  'hematocrit',
  'rbcDistributionWidth',
  'plateletCount',
  'meanPlateletVolume',
  'neutrophils',
  'lymphocytes',
  'monocytes',
  'eosinophils',
  'basophils',
  'glucose',
  'bun',
  'creatinine',
  'eGFR',
  'eGFRforAA',
  'sodium',
  'potassium',
  'chloride',
  'carbonDioxide',
  'calcium',
  'protein',
  'albumin',
  'bilirubin',
  'alkalinePhosphatase',
  'ast',
  'alt',
  'cholesterol',
  'hdl',
  'triglycerides',
  'ldl',
  'apolipoproteinA1',
  'apolipoproteinB',
  'lipoproteinA',
  'iron',
  'tibc',
  'ferritin',
  'transferrin',
  'tsh',
  't4Total',
  't4Free',
  't3Total',
  't3Free',
  'reverseT3',
  'tpoAb',
  'tgAb',
  'tbg',
  't3Uptake',
  'freeT4Index',
  'amylase',
  'bileAcids',
  'bilirubinDirect',
  'bilirubinIndirect',
  'ceruloplasmin',
  'copperRBCμgmL',
  'copperRBCμgdL',
  'copperSerumμgdL',
  'copperSerummcgmL',
  'cpeptide',
  'dDimer',
  'fibrinogen',
  'folateRBC',
  'folateSerum',
  'ggt',
  'hemoglobinA1c',
  'homocysteine',
  'hsCRP',
  'insulin',
  'lactateDehydrogenase',
  'magnesiumRBC',
  'magnesium',
  'phosphorus',
  'reticulocyteCount',
  'esr',
  'uricAcid',
  'vitaminB6',
  'vitaminB12',
  'vitaminD',
  'vitaminD125',
  'zincRBCμgdL',
  'zincRBCmgL',
  'zincSerumμgdL',
  'zincSerummcgmL',
  'antiMullerianHormone',
  'cortisolAM',
  'cortisolPM',
  'dheaS',
  'dihydrotestosterone',
  'estradiolE2',
  'estriolE3',
  'estrogensTotal',
  'estroneE1',
  'fsh',
  'hCG',
  'igf1',
  'lh',
  'pregnenolone',
  'progesterone',
  'hydroxyprogesterone17',
  'prolactin',
  'prolactinLactating',
  'shbg',
  'testosteroneBioavailable',
  'testosteroneBioavailablePercent',
  'testosteroneFreeCalc',
  'testosteroneFreeDirect',
  'testosteroneTotal',
  'testosteroneTotalLCMS',
];

const filteredPairs = [
  ['whiteBloodCells', 'WBC (White Blood Cells)'],
  ['redBloodCells', 'RBC (Red Blood Cells)'],
  ['hemoglobin', 'HGB (Hemoglobin)'],
  ['hematocrit', 'HCT (Hematocrit)'],
  ['rbcDistributionWidth', 'RDW (RBC Distribution Width)'],
  ['plateletCount', 'Platelet Count'],
  ['meanPlateletVolume', 'MPV (Mean Platelet Volume)'],
  ['glucose', 'Glucose'],
  ['bun', 'BUN (Blood Urea Nitrogen)'],
  ['creatinine', 'Creatinine'],
  ['eGFR', 'eGFR (Non-Afr. American)'],
  ['eGFRforAA', 'eGFR (African American)'],
  ['sodium', 'Sodium (Na)'],
  ['potassium', 'Potassium (K)'],
  ['chloride', 'Chloride (CI)'],
  ['carbonDioxide', 'Carbon Dioxide (CO2)'],
  ['calcium', 'Calcium (Ca)'],
  ['protein', 'Protein, Total'],
  ['albumin', 'Albumin'],
  ['bilirubin', 'Bilirubin, Total'],
  ['alkalinePhosphatase', 'Alkaline Phosphatase (ALP)'],
  ['ast', 'AST (SGOT)'],
  ['alt', 'ALT (SGPT)'],
  ['cholesterol', 'Cholesterol, Total'],
  ['hdl', 'HDL Cholesterol'],
  ['triglycerides', 'Triglycerides'],
  ['ldl', 'LDL Cholesterol'],
  ['apolipoproteinA1', 'Apolipoprotein A-1 (Apo A-1)'],
  ['apolipoproteinB', 'Apolipoprotein B (Apo B)'],
  ['lipoproteinA', 'Lipoprotein(a)'],
  ['iron', 'Iron, Total'],
  ['tibc', 'TIBC (Total Iron Binding Capacity)'],
  ['ferritin', 'Ferritin'],
  ['transferrin', 'Transferrin'],
  ['tsh', 'TSH'],
  ['t4Total', 'T4 (Thyroxine), Total'],
  ['t4Free', 'T4, Free'],
  ['t3Total', 'T3 (Triiodothyronine), Total'],
  ['t3Free', 'T3, Free'],
  ['reverseT3', 'Reverse T3'],
  ['tpoAb', 'Thyroid Peroxidase Antibodies (TPO Ab)'],
  ['tgAb', 'Thyroglobulin Antibodies (Tg Ab)'],
  ['tbg', 'Thyroxine Binding Globulin (TBG)'],
  ['t3Uptake', 'T3 Uptake'],
  ['freeT4Index', 'Free Thyroxine (T4) Index (FTI, T7)'],
  ['amylase', 'Amylase'],
  ['bileAcids', 'Bile Acids'],
  ['bilirubinDirect', 'Bilirubin, Direct'],
  ['bilirubinIndirect', 'Bilirubin, Indirect'],
  ['ceruloplasmin', 'Ceruloplasmin'],
  ['copperRBCμgmL', 'Copper, RBC'],
  ['copperRBCμgdL', 'Copper, RBC'],
  ['copperSerumμgdL', 'Copper, serum'],
  ['copperSerummcgmL', 'Copper, serum'],
  ['cpeptide', 'C-peptide'],
  ['dDimer', 'D-Dimer'],
  ['fibrinogen', 'Fibrinogen'],
  ['folateRBC', 'Folate, RBC'],
  ['folateSerum', 'Folate, serum'],
  ['ggt', 'Gamma Glutamyl Transferase (GGT)'],
  ['hemoglobinA1c', 'Hemoglobin A1c'],
  ['homocysteine', 'Homocysteine'],
  ['hsCRP', 'hs-CRP'],
  ['insulin', 'Insulin'],
  ['lactateDehydrogenase', 'Lactate Dehydrogenase (LDH, LD)'],
  ['magnesiumRBC', 'Magnesium, RBC'],
  ['magnesium', 'Magnesium, serum'],
  ['phosphorus', 'Phosphorus'],
  ['reticulocyteCount', 'Reticulocyte Count'],
  ['esr', 'Sedimentation Rate (Erythrocyte Sed Rate, ESR)'],
  ['uricAcid', 'Uric Acid'],
  ['vitaminB6', 'Vitamin B6, plasma'],
  ['vitaminB12', 'Vitamin B12, serum'],
  ['vitaminD', 'Vitamin D (25-OH)'],
  ['vitaminD125', 'Vitamin D, 1,25 (OH)2'],
  ['zincRBCμgdL', 'Zinc, RBC'],
  ['zincRBCmgL', 'Zinc, RBC'],
  ['zincSerumμgdL', 'Zinc, serum or plasma'],
  ['zincSerummcgmL', 'Zinc, serum or plasma'],
  ['antiMullerianHormone', 'Anti-Mullerian Hormone (AMH)'],
  ['cortisolAM', 'Cortisol, AM'],
  ['cortisolPM', 'Cortisol, PM'],
  ['dheaS', 'DHEA Sulfate'],
  ['dihydrotestosterone', 'Dihydrotestosterone (DHT)'],
  ['estradiolE2', 'Estradiol, E2'],
  ['estriolE3', 'Estriol, E3'],
  ['estrogensTotal', 'Estrogens, Total'],
  ['estroneE1', 'Estrone, E1'],
  ['fsh', 'Follicle Stimulating Hormone (FSH)'],
  ['hCG', 'Human Chorionic Gonadotropin (hCG)'],
  ['igf1', 'Insulin-like Growth Factor-1 (IGF-1)'],
  ['lh', 'Luteinizing Hormone (LH)'],
  ['pregnenolone', 'Pregnenolone, LC/MS'],
  ['progesterone', 'Progesterone'],
  ['hydroxyprogesterone17', '17-Hydroxyprogesterone (17-OHP)'],
  ['prolactin', 'Prolactin'],
  ['prolactinLactating', 'Prolactin'],
  ['shbg', 'Sex Hormone Binding Globulin (SHBG)'],
  [
    'testosteroneBioavailable',
    'Testosterone, Bioavailable (Free + Weakly Bound)',
  ],
  [
    'testosteroneBioavailablePercent',
    'Testosterone, Bioavailable (Free + Weakly Bound) %',
  ],
  ['testosteroneFreeCalc', 'Testosterone, Free, Calc'],
  ['testosteroneFreeDirect', 'Testosterone, Free, Direct'],
  ['testosteroneTotal', 'Testosterone, Total'],
  ['testosteroneTotalLCMS', 'Testosterone, Total, LC/MS'],
];

// const prompt = `
// Parse the contents of a PDF file containing a patient's lab results to extract specific data.

// Ensure that the extraction process effectively identifies and matches test results to their corresponding identifiers from a provided list, leveraging efficient search techniques to avoid missing any relevant analyses. Present the extracted data in a structured JSON format.

// # Test Identifiers:

// - Each test has a unique identifier and potential names/abbreviations that may appear in the document.
// - Select the label that best aligns with the identifier, especially when multiple possibilities exist.

// # Predefined list:

// whiteBloodCells (WBC), redBloodCells (RBC), hemoglobin (Hemoglobin), hematocrit (Hematocrit), rbcDistributionWidth (RDW), plateletCount (Platelets), meanPlateletVolume (MPV), neutrophils (Neutrophils), lymphocytes (Lymphs), monocytes (Monocytes), eosinophils (Eos), basophils (Basos), glucose (Glucose), bun (BUN), creatinine (Creatinine), eGFR (eGFR), sodium (Sodium), potassium (Potassium), chloride (Chloride), carbonDioxide (Carbon Dioxide, Total), calcium (Calcium), protein (Protein, Total), albumin (Albumin), globulin (Globulin, Total), albuminGlobulinRatio (A/G Ratio), bilirubin (Bilirubin, Total), alkalinePhosphatase (Alkaline Phosphatase), ast (AST (SGOT)), alt (ALT (SGPT)), cholesterol (Cholesterol, Total), hdl (HDL Cholesterol), triglycerides (Triglycerides), ldl (LDL Chol Calc or LDL-C (NIH Calc)), cholesterolHDLRatio (T. Chol/HDL Ratio), triglyceridesHDLRatio (n/a), apolipoproteinA1 (Apolipoprotein A-1), apolipoproteinB (Apolipoprotein B), apoBapoA1Ratio (Apolipo. B/A-1 Ratio), lipoproteinA (Lipoprotein (A)), tibc (Iron Bind. Cap. (TIBC)), iron (Iron), saturation (Iron Saturation), ferritin (Ferritin), transferrin (Transferrin), tsh (TSH), t4Total (Thyroxine (T4)), t4Free (T4, Free(Direct)), t3Total (Triiodothyronine (T3)), t3Free (Triiodothyronine (T3), Free), reverseT3 (Reverse T3, Serum), tpoAb (Thyroid Peroxidase (TPO) Ab), tgAb (Thyroglobulin Antibody), tbg (Thyroxine Binding Globulin), t3Uptake (T3 Uptake), freeT4Index (Free Thyroxine Index), amylase (Amylase), bileAcids (Bile Acids), bilirubinDirect (Bilirubin, Direct), bilirubinIndirect (Bilirubin, Indirect), ceruloplasmin (Ceruloplasmin), copperRBCμgmL (Copper, RBC), copperRBCμgdL (n/a), copperSerumμgdL (n/a), copperSerummcgmL (Copper, Serum or Plasma or Copper, Pl), cpeptide (C-Peptide, Serum), dDimer (D-Dimer), fibrinogen (Fibrinogen Activity), folateRBC (Folate, RBC), folateSerum (Folate (Folic Acid), Serum), ggt (GGT), hemoglobinA1c (Hemoglobin A1c), homocysteine (Homocysteine), hsCRP (cReactiveProtein or C-Reactive Protein, Cardiac), insulin (Insulin), lactateDehydrogenase (LDH), magnesiumRBC (Magnesium, RBC), magnesium (Magnesium), phosphorus (Phosphorus), reticulocyteCount (Reticulocyte Count), esr ("Sedimentation), Rate-Westergren"), uricAcid (Uric Acid), vitaminB6 (Vitamin B6), vitaminB12 (Vitamin B12), vitaminD (Vitamin D, 25-Hydroxy), vitaminD125 (Calcitriol(1,25 di-OH Vit D)), zincRBCμgdL (Zinc, RBC), zincRBCmgL (n/a), zincSerumμgdL (Zinc, Plasma or Serum), zincSerummcgmL (n/a), (https://www.labcorp.com/test-menu/search), antiMullerianHormone (Anti-Mullerian Hormone (AMH)), cortisolAM (Cortisol (AM)), cortisolPM (Cortisol (PM)), dheaS (DHEA-Sulfate), dihydrotestosterone (Dihydrotestosterone), estradiolE2 (Estradiol), estriolE3 (Estriol, Serum), estrogensTotal (Estrogens, Total), estroneE1 (Estrone, Serum), fsh (FSH), hCG (hCG, Beta Subunit, Qual), igf1 (IGF-1), lh (LH), pregnenolone (Pregnenolone, MS), progesterone (Progesterone), hydroxyprogesterone17 (17-OH Progesterone LCMS), prolactin (Prolactin), shbg (Sex Horm Binding Glob, Serum), testosteroneBioavailable (Testost., F+W Bound), testosteroneBioavailablePercent (Testost., % Free+Weakly Bound), testosteroneFreeCalc (Testost., Free, Calc), testosteroneFreeDirect (Free Testosterone(Direct)), testosteroneTotal (Testosterone or Testosterone, Serum), testosteroneTotalLCMS (Testosterone, Total, LC/MS)

// # Steps

// 1. **Extract Key Fields**
//    - Extract the patient's name and test collection date.
//    - Sequentially go through the entire predefined list above and try to find the current analysis result for each item. If found, add the result to the response. If not found, just skip this element and move on to the next one.
//    - Once the list is complete, walk through the result and make sure all identifiers are present in the predefined list. Also, add array of predefined identifiers to response.
//    - Compare the identifiersFromPredefinedList and results lists and add a “differingIdentifiers” field to the response, which will contain identifiers from results that are not in identifiersFromPredefinedList

// 2. **Format the Output in JSON**
//    - Structure the data in the following JSON format:

// ```json
// {
//   "name": "Patient Name",
//   "date": "Test Collection Date",
//   "identifiersFromPredefinedList": ["identifier1", "indentifier2", ...],
//   "results": [
//     {
//       "label": "Identifier from the provided list",
//       "value": "Test result"
//     },
//     ...
//   ],
//   "differingIdentifiers": ["indentifier", ...]
// }
// ```

// # Output Format

// - The output should be in JSON format, including only the required fields and explicitly reported zero values.

// # Examples

// Example Input:
// A PDF containing:
// - Patient Name: John Doe
// - Date: 2025-01-04
// - Lab Results: WBC: 4.5 x10^9/L, Hemoglobin: 13.9 g/dL, Sodium: Not detected

// Example Output:
// ```json
// {
//   "name": "John Doe",
//   "date": "2025-01-04",
//   "identifiersFromPredefinedList": ["whiteBloodCells", "hsCRP", ...],
//   "results": [
//     {
//       "label": "whiteBloodCells",
//       "value": "4.5"
//     },
//     {
//       "label": "hsCRP",
//       "value": "0.30"
//     }
//   ],
//   "differingIdentifiers": ["cReactiveProtein", ...]
// }
// ```
// `;
